var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 17.9999H3.33333C2.875 17.9999 2.5 17.6249 2.5 17.1666V7.74159C2.5 7.39159 2.70833 7.08325 3.03333 6.95825L12.2 3.43325C12.75 3.22492 13.3333 3.62492 13.3333 4.21659V8.83325H6.66667C6.20833 8.83325 5.83333 9.20825 5.83333 9.66659V17.9999ZM14.1667 10.4999H8.33333C7.875 10.4999 7.5 10.8749 7.5 11.3333V17.1666C7.5 17.6249 7.875 17.9999 8.33333 17.9999H11.6667V14.6666C11.6667 14.2083 12.0417 13.8333 12.5 13.8333C12.9583 13.8333 13.3333 14.2083 13.3333 14.6666V17.9999H16.6667C17.125 17.9999 17.5 17.6249 17.5 17.1666V10.4999C17.5 9.58325 16.75 8.83325 15.8333 8.83325C14.9167 8.83325 14.1667 9.58325 14.1667 10.4999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResort);
export default __webpack_public_path__ + "static/media/resort.499d492f8f9e8340c741af1659a0fcdb.svg";
export { ForwardRef as ReactComponent };